import { getValueForMap } from "../../utils/Util.tsx";

export const getProductChart =(key)=> {
  return{
 maintainAspectRatio: false,
  cutout: "65%",
  layout: {
    padding: 0,
  },
  plugins: {
    responsive: true,
    datalabels: {
      display: true,
      color: "#FFFFFFF0",
      formatter: (value) => getValueForMap(value),
      anchor: "center",
      align: "center",
      font: {
        size: 10,
      },
    },
    legend: {
      position: "bottom",
      display: true,
      align: "center",
      labels: {
        usePointStyle: true, // Enables custom point style
        pointStyle: "circle", // Makes legend markers circular
        boxWidth: 10, // Optional: controls size of the circle
        padding: 15, // Optional: spacing between items

        font: {
          size: 12,
        },
      },
    },
  },
   scales: {
    x: {
      display: key==='Amount Disbursed' ? true: false, // hides the entire x-axis including ticks and grid lines
      grid: {
        display:  key==='Amount Disbursed' ? true: false,
      },
      ticks: {
        display:  key==='Amount Disbursed' ? true: false,
      },
    },
    y: {
      display: key==='Amount Disbursed' ? true: false, // hides the entire y-axis including ticks and grid lines
      grid: {
        display:  key==='Amount Disbursed' ? true: false,
      },
      ticks: {
        display:  key==='Amount Disbursed' ? true: false,
      },
    },
  },
  }
};
export const STATE_CHART = {
  maintainAspectRatio: false,
  cutout: "65%",
  layout: {
    padding: 0,
  },
  plugins: {
    responsive: true,
    datalabels: {
      display: true,
      color: "#FFFFFFF0",
      formatter: (value) => getValueForMap(value),
      anchor: "center",
      align: "center",
      font: {
        size: 10,
      },
    },
    legend: {
      position: "bottom",
      display: true,
      align: "center",
      labels: {
        usePointStyle: true, // Enables custom point style
        pointStyle: "circle", // Makes legend markers circular
        boxWidth: 10, // Optional: controls size of the circle
        padding: 15, // Optional: spacing between items

        font: {
          size: 12,
        },
      },
    },
  },
};
export const getAmountDisbursedOptions = (levelTwo, key) => {
  return {
    maintainAspectRatio: false,
    cutout: "65%",
    layout: {
      padding: 0,
    },
    indexAxis: key === "states" ? "x" : "y",
    responsive: true,
    plugins: {
      datalabels: {
        display: true,
        color: "#FFFFFFF0",
        formatter: (value) => getValueForMap(value),
        anchor: "center",
        align: "center",
        font: {
          size: 10,
        },
      },
      legend: {
        position: "bottom",
      },
    },
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: key === "states" ? key : "",
        },
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: key === "Perils" ? key : "",
        },
      },
    },
  };
};

export const getStateChartOption = (xText: string, yText: string) => {
  return {
    maintainAspectRatio: false,
    cutout: "65%",
    layout: {
      padding: 0,
    },
    scales: {
      x: {
        title: {
          display: true,
          text: xText,
        },
      },
      y: {
        title: {
          display: true,
          text: yText,
        },
      },
    },
    plugins: {
      datalabels: {
        display: true,
        color: "#FFFFFFF0",
        formatter: (value) => getValueForMap(value),
        anchor: "center",
        align: "center",
        font: {
          size: 12,
        },
      },
      responsive: true,
      legend: {
        position: "bottom",
        display: false,
        align: "center",
      },
    },
  };
};
export const TARGET_CHART = {
  responsive: true,
  maintainAspectRatio: false,

  plugins: {
    datalabels: {
      display: true,
      color: "#FFFFFFF0",
      formatter: (value) => getValueForMap(value),
      anchor: "center",
      align: "center",
      font: {
        size: 10,
      },
    },
    legend: { position: "bottom" },
  },
  scales: {
    x: {
      stacked: true,
      title: {
        display: true,
        text: "States",
      },
    },
    y: {
      stacked: true,
      title: {
        display: true,
        text: "Targets",
      },
    },
  },
};

export const getGridChartOption = (xText: string, yText: string) => {
  return {
    indexAxis: "y",
    maintainAspectRatio: false,
    cutout: "65%",
    layout: {
      padding: 0,
    },
    scales: {
      x: {
        title: {
          display: true,
          text: yText,
        },
      },
      y: {
        title: {
          display: true,
          text: xText,
        },
      },
    },
    plugins: {
      datalabels: {
        display: true,
        color: "#FFFFFFF0",
        formatter: (value) => getValueForMap(value),
        anchor: "center",
        align: "center",
        font: {
          size: 12,
        },
      },
      responsive: true,
      legend: {
        position: "bottom",
        display: false,
        align: "center",
      },
    },
  };
};
export const CROP_CHART = {
  maintainAspectRatio: false,
  cutout: "65%",
  layout: {
    padding: 0,
  },

  scales: {
    x: {
      display: false, // hides x-axis
      grid: {
        display: false, // hides x-axis grid lines
      },
    },
    y: {
      display: false, // hides y-axis
      grid: {
        display: false, // hides y-axis grid lines
      },
    },
  },

  plugins: {
    responsive: true,
    datalabels: {
      display: true,
      color: "#FFFFFFF0",
      formatter: (value) => getValueForMap(value?.y),
      anchor: "center",
      align: "center",
      font: {
        size: 10,
      },
    },
    legend: {
      position: "bottom",
      display: false,
      align: "center",
      labels: {
        usePointStyle: true, // Enables custom point style
        pointStyle: "circle", // Makes legend markers circular
        boxWidth: 10, // Optional: controls size of the circle
        padding: 15, // Optional: spacing between items

        font: {
          size: 12,
        },
      },
    },
  },
};

export const PERIL_CHART = {
  maintainAspectRatio: false,
  layout: {
    padding: 0,
  },
  plugins: {
    datalabels: {
      display: true,
      color: "#FFFFFFF0",
      formatter: (value) => getValueForMap(value),
      anchor: "center",
      align: "center",
      font: {
        size: 10,
      },
    },
    responsive: true,
    legend: {
      position: "bottom",
      display: true,
      align: "center",
      labels: {
        usePointStyle: true, // Enables custom point style
        pointStyle: "circle", // Makes legend markers circular
        boxWidth: 10, // Optional: controls size of the circle
        padding: 15, // Optional: spacing between items

        font: {
          size: 12,
        },
      },
    },
  },
};
